import { SELLER_DATA_VOID } from "@shared-logic/subjects";
import { PLACE_OF_ORIGIN_VOID } from "@shared-logic/locations";
import { WAY_PAY_VOID } from "@shared-logic/payments";
import { orderInitialState, OBJECT_ID_VOID } from "./order.constants";
import { OrderExchange, Exchange } from "./order-exchange.interface";
//import { OBJECT_ID_VOID } from "./utils";

// Check where OBJECT_ID_VOID is. In frontend it was './options'.
// content of frontend 'src/app/shared/const/options.ts':
// export const OBJECT_ID_VOID = "000000000000000000000000";
// I should probably define it here or import if available.
// I'll check shared-logic/orders/order.constants.ts to see if it is there.
// If not, I'll define it locally for now or look for it.

export const exchangeTags = {
    exchange: 'exchange',
    status: 'status',
    buyer: 'buyer',
    agreedDiscount: 'agreedDiscount',
    priceDiscount: 'priceDiscount',
    percentageB: 'percentageB',
    amountB: 'amountB',
    motherContract: 'motherContract',
}

export const exchangeInitialState: Exchange = {
    status: -1,
    buyer: SELLER_DATA_VOID,
    tons: -1,
    howSell: -1,
    purchaseMethod: 0,
    placeOfOrigin: PLACE_OF_ORIGIN_VOID,
    price: -1,
    typeCoin: '--',
    codeWayPay: -1,
    daysWayPay: -1,
    contractNumber: -1,
    agreedDiscount: -1,
    priceDiscount: -1,
    wayPay: WAY_PAY_VOID,
    isFixedPrice: false,
    amountB: -1,
    percentageB: -1,
    isMotherCounterpart: -1,
    idMother: '000000000000000000000000', // OBJECT_ID_VOID literal
}

export const orderExchangeInitialState: OrderExchange = {
    ...orderInitialState,
    exchange: exchangeInitialState
}

export const EXCHANGE_STATUS_CONST = {
    INCOMPLETO: 1,
    VERIFICAR: 2,
    COMPLETA: 3,
}
